<template>
  <div :class="{ 'bg-gray-brand-200': enlarged }" data-testid="product-modal-hero">
    <ProductPhotoCarousel
      :urls="urls"
      :alt="alt"
      :photo-class="photoClass"
      test-id-prefix="product-modal"
      @photo-click="enlarged = !enlarged"
    />
  </div>
</template>

<script>
import ProductPhotoCarousel from '@/components/Product/ProductPhotoCarousel.vue'

export default {
  name: 'ProductModalPhotos',

  components: { ProductPhotoCarousel },

  props: {
    urls: { type: Array, required: true },
    alt: { type: String, default: '' }
  },

  data() {
    return { enlarged: false }
  },

  computed: {
    photoClass() {
      return this.enlarged
        ? 'w-full h-[60vh] object-contain cursor-zoom-out'
        : 'w-full h-56 object-cover cursor-zoom-in'
    }
  }
}
</script>
